import axios from 'axios'

export default {
    uploadFile:function (fileObj,relType,relId){
        let formData = new FormData();
        formData.set("file", fileObj.file);
        formData.set("fileEntity.relType", relType);
        formData.set("fileEntity.relId", relId);
        return axios.post('/file/uploadFile', formData, {
                headers: {
                    "Content-type": "multipart/form-data"
                }
            }).then().catch();
    },
    getList: function (params){
        return axios.post('/file/pageList', params).then(res => {
            return res.data.data
        }).catch();
    },
    download:function (url){
        window.location.href=url;
    },
    delete:function (id){
        return axios.get('/file/delFile?id='+id).then().catch();
    }
}